<template>
  <div class="d-none">
    <div class="lpu-schedule">
      <LpuScheduleSkeleton v-if="isVisibleSkeleton" />
      <template v-else>
        <div class="lpu-schedule__days">
          <div
            v-for="(time, day) in schedule.schedule_days"
            :key="day"
            class="lpu-schedule__day d-flex"
            :class="{
              'text-subtitle-1 lpu-schedule__day--current': day === schedule.now_weekday_translit,
              'text-body-1': day !== schedule.now_weekday_translit,
            }"
          >
            <div class="lpu-schedule__date">
              {{ $t(schedule.full_days[day], options) }}
            </div>
            {{ $t(time, options) }}
          </div>
        </div>

        <v-divider
          v-if="schedule.lpu_exceptions.length"
          class="lpu-schedule__divider"
          vertical
        />

        <div
          v-if="schedule.lpu_exceptions.length"
          class="lpu-schedule__days"
        >
          <div class="text-subtitle-1 text--text">
            {{ $t('График работы в праздники', options) }}
          </div>
          <div
            v-for="(exception, index) in schedule.lpu_exceptions"
            :key="`holiday-${index}`"
            class="lpu-schedule__day text-body-1"
          >
            <div class="lpu-schedule__date">
              {{ $t(exception.date, options) }}
            </div>
            {{ $t(exception.time, options) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import LpuScheduleSkeleton from 'www/vue_components/common/LpuSchedule/components/common/LpuScheduleSkeleton.vue'

export default {
  name: 'LpuSchedule',
  components: {
    LpuScheduleSkeleton,
  },
  props: {
    /**
     * interface
     * schedule: Schedule
     */
    schedule: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: { ns: this.$i18next.language },
    }
  },
  computed: {
    isVisibleSkeleton() {
      return this.loading || !this.schedule
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.lpu-schedule {
  display: flex;

  &__date {
    flex-basis: 50%;
  }

  &__days {
    min-width: 268px;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  &__day {
    display: flex;
    column-gap: 16px;

    &--current {
      color: $ui-kit-text;
    }

    &:not(&--current) {
      color: $ui-kit-text-secondary;
    }
  }

  &__divider {
    margin: 0 24px;
  }
}
</style>
